import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-itc-trade-modal',
  standalone: false,
  templateUrl: './itc-trade-modal.component.html',
  styleUrl: './itc-trade-modal.component.scss',
})
export class ItcTradeModalComponent {
  itcTradeText: string = `Your order will have to undergo international compliance checks, which
          may cause a delay in processing, for any related questions feel free
          to contact our Customer Care Team.`;

  constructor(private matDialogRef: MatDialogRef<ItcTradeModalComponent>) {
    this.matDialogRef.disableClose = true;
  }

  closeModal(type: boolean) {
    this.matDialogRef.close({ proceed: type });
  }
}
